import { Legend } from "@nens/lizard/api-v4";

import { useWmsLegendQuery } from "@/queries/query-wms-legend";

type UseClosestDiscreteLegendStepArgs = {
  descriptorId: string;
  layer: string;
  styleId: string;
  value: number | null;
};

type LegendStep = Legend["legend"][number];

type DiscreteLegendReturn = {
  closestStep: LegendStep | null;
  labels: Legend["labels"];
};

const getClosestLegendStep = (legend: Legend["legend"], value: number): LegendStep => {
  return legend.reduce((closest, step) =>
    Math.abs(step.value - value) < Math.abs(closest.value - value) ? step : closest
  );
};

// If the legend is discrete we want to display the legend step that is closest to the value at the clicked point.
// This makes it clear to the user which category the value belongs to according to the legend.
// If we would display the actual value instead it would just say 5.4 for example which means nothing to the user
export const useClosestDiscreteLegendStep = ({
  descriptorId,
  layer,
  styleId,
  value,
}: UseClosestDiscreteLegendStepArgs): DiscreteLegendReturn => {
  const legendResponse = useWmsLegendQuery(descriptorId, layer, styleId);

  if (!legendResponse.isSuccess || value === null) return { closestStep: null, labels: {} };

  const { colormap_type, legend, labels } = legendResponse.data;

  if (colormap_type !== "discrete") return { closestStep: null, labels: {} };

  return { closestStep: getClosestLegendStep(legend, value), labels };
};
